/* heon-pages.js: owned by the pages team (2026-09-26). Loaded with heon-pages.css.
   1. FAQ accordions (<details class="hp-qa">): smooth open/close, one-line hash links open the question.
   2. Ring size finder: type a measurement, the nearest row of the chart lights up.
   3. Care menu: highlights the section you are reading (when the page lists its sections).
   4. "Live chat" buttons open Shopify Inbox; "Copy link" on Journal articles.
   5. Journal tables: wrapped so they scroll sideways on phones instead of breaking the page (a table with
      class="hp-tstack" stacks into cards on phones instead, see heon-pages.css). */
(function () {
  if (window.__hpPages) return;
  window.__hpPages = true;
  function T(k, d) { var s = window.HeonI18n && window.HeonI18n[k]; return typeof s === 'string' && s ? s : d; }   // the page's language (snippets/heon-i18n-js), else the English default
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* 1. accordions */
  function initFaq(root) {
    root.querySelectorAll('details.hp-qa').forEach(function (d) {
      if (d.__hp) return;
      d.__hp = true;
      var sum = d.querySelector('summary');
      var body = d.querySelector('.hp-qa-a');
      if (!sum || !body) return;
      sum.addEventListener('click', function (e) {
        if (reduce || !body.animate) return;
        e.preventDefault();
        if (d.__anim) d.__anim.cancel();
        if (d.open) {
          var h = body.offsetHeight;
          d.__anim = body.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 260, easing: 'cubic-bezier(.2,.7,.2,1)' });
          d.classList.add('is-closing');
          d.__anim.onfinish = function () { d.open = false; d.classList.remove('is-closing'); d.__anim = null; };
          d.__anim.oncancel = function () { d.classList.remove('is-closing'); };
        } else {
          d.open = true;
          var h2 = body.offsetHeight;
          d.__anim = body.animate([{ height: '0px', opacity: 0 }, { height: h2 + 'px', opacity: 1 }], { duration: 320, easing: 'cubic-bezier(.2,.7,.2,1)' });
          d.__anim.onfinish = function () { d.__anim = null; };
        }
      });
    });
    openFromHash();
  }
  function openFromHash() {
    var id = decodeURIComponent((location.hash || '').slice(1));
    if (!id) return;
    var el = document.getElementById(id);
    if (el && el.matches && el.matches('details.hp-qa')) {
      el.open = true;
      setTimeout(function () { el.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' }); }, 60);
    }
  }
  window.addEventListener('hashchange', openFromHash);

  /* 2. ring size finder */
  function initFinder(root) {
    root.querySelectorAll('[data-hp-finder]').forEach(function (box) {
      if (box.__hp) return;
      box.__hp = true;
      var table = document.getElementById(box.getAttribute('data-table'));
      if (!table) return;
      var rows = Array.prototype.slice.call(table.querySelectorAll('tbody tr[data-us]'));
      if (!rows.length) return;
      var input = box.querySelector('input[type="number"]');
      var out = box.querySelector('.hp-finder-out');
      var radios = box.querySelectorAll('input[type="radio"]');
      var contact = box.getAttribute('data-contact') || '/pages/contact';
      box.hidden = false;

      function mode() {
        var m = 'd';
        radios.forEach(function (r) { if (r.checked) m = r.value; });
        return m;
      }
      function clear() { rows.forEach(function (tr) { tr.classList.remove('is-match', 'is-near'); }); }
      function say(html) { out.innerHTML = html; }

      function update() {
        clear();
        var raw = (input.value || '').replace(',', '.');
        var v = parseFloat(raw);
        var m = mode();
        if (input) input.placeholder = m === 'c' ? '54.4' : '17.3';
        if (!raw || isNaN(v)) { say('<span class="hp-finder-hint">' + T('ring_hint', 'Type a number in millimeters to see your size.') + '</span>'); return; }
        var key = m === 'c' ? 'c' : 'd';
        var vals = rows.map(function (tr) { return parseFloat(tr.getAttribute('data-' + key)); });
        var lo = vals[0], hi = vals[vals.length - 1];
        var step = (hi - lo) / (vals.length - 1);
        if (m === 'd' && v > 40 && v <= 90) {
          say(T('ring_circ_html', 'That looks like a circumference. Choose <b>Around my finger</b> above, or measure across the inside of a ring.').replace('<b>', '<b style="font-size:inherit">'));
          return;
        }
        if (m === 'c' && v < 30) {
          say(T('ring_diam_html', 'That looks like a diameter. Choose <b>A ring, across the inside</b> above.').replace('<b>', '<b style="font-size:inherit">'));
          return;
        }
        if (v < lo - step || v > hi + step) {
          say(T('ring_outside_html', 'That is outside our chart (US [a] to [b]). Measure again, or <a>ask us</a> and we will help.')
            .replace('[a]', function () { return rows[0].getAttribute('data-us'); }).replace('[b]', function () { return rows[rows.length - 1].getAttribute('data-us'); })
            .replace('<a>', function () { return '<a href="' + contact + '">'; }));
          return;
        }
        var best = 0, bestD = Infinity;
        vals.forEach(function (x, i) { var dd = Math.abs(x - v); if (dd < bestD) { bestD = dd; best = i; } });
        var tr = rows[best];
        tr.classList.add('is-match');
        var msg = '<b>' + T('ring_us', 'US') + ' ' + tr.getAttribute('data-us') + '</b> ' + T('ring_uk', 'UK') + ' ' + tr.getAttribute('data-uk');
        /* between two sizes: point to the larger one, like most jewelers advise */
        var x = vals[best];
        var other = v > x ? best + 1 : best - 1;
        if (bestD > step * 0.25 && other >= 0 && other < rows.length) {
          rows[other].classList.add('is-near');
          var up = v > x ? rows[other] : tr;
          msg += '<br>' + T('ring_between_html', 'Between two sizes? Choose the larger one, US [x], or <a>ask us</a>.')
            .replace('[x]', function () { return up.getAttribute('data-us'); }).replace('<a>', function () { return '<a href="' + contact + '">'; });
        }
        say(msg);
      }
      if (input) {
        input.addEventListener('input', update);
        input.addEventListener('change', update);
      }
      radios.forEach(function (r) { r.addEventListener('change', update); });
      update();
    });
  }

  /* 3. menu follows the reading position */
  /* the current section is the last heading that has passed 30% of the window; above the first one, the first
     is current (an IntersectionObserver kept the last item lit after scrolling back to the top: audit P3-34) */
  function initToc(root) {
    var links = Array.prototype.slice.call(root.querySelectorAll('.hp-toc a[href^="#"]'));
    var pairs = links.map(function (a) { return [a, document.getElementById(decodeURIComponent(a.getAttribute('href').slice(1)))]; })
      .filter(function (p) { return p[1]; });
    if (!pairs.length) return;
    var ticking = false;
    function update() {
      ticking = false;
      var line = window.innerHeight * 0.3, cur = pairs[0][0];
      pairs.forEach(function (p) { if (p[1].getBoundingClientRect().top <= line) cur = p[0]; });
      links.forEach(function (a) { a.classList.toggle('is-on', a === cur); });
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* 4. live chat, copy link */
  function openChat() {
    var host = document.querySelector('inbox-online-store-chat, shopify-chat, #ShopifyChat');
    var btn = null;
    if (host && host.shadowRoot) btn = host.shadowRoot.querySelector('button');
    if (!btn) btn = document.querySelector('[aria-label*="chat" i][role="button"], button[aria-label*="chat" i]');
    if (btn) { btn.click(); return true; }
    return false;
  }
  document.addEventListener('click', function (e) {
    var chat = e.target.closest && e.target.closest('[data-hp-chat]');
    if (chat) {
      e.preventDefault();
      if (!openChat()) {
        var note = chat.parentNode.querySelector('.hp-chat-note');
        if (!note) {
          note = document.createElement('p');
          note.className = 'hp-fine hp-chat-note';
          note.setAttribute('role', 'status');
          note.style.marginTop = '10px';
          chat.parentNode.appendChild(note);
        }
        note.innerHTML = T('chat_loading', 'The chat is still loading. Use the chat button at the bottom corner of the page, or email [email].')
          .replace('[email]', '<a href="mailto:support@heonjewelry.com">support@heonjewelry.com</a>');
      }
      return;
    }
    var copy = e.target.closest && e.target.closest('[data-hp-copy]');
    if (copy) {
      e.preventDefault();
      var url = copy.getAttribute('data-hp-copy');
      var label = copy.textContent;
      var done = function () { copy.textContent = T('copied', 'Link copied'); setTimeout(function () { copy.textContent = label; }, 2200); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, function () { window.prompt(T('copy_link', 'Copy this link'), url); });
      else window.prompt(T('copy_link', 'Copy this link'), url);
    }
  });

  /* 5. article tables */
  function wrapTables(root) {
    root.querySelectorAll('.hp-prose--article table, .hp-prose--page table').forEach(function (t) {
      if (t.parentNode.classList.contains('hp-tscroll') || t.parentNode.classList.contains('scrollable-table')) return;
      var w = document.createElement('div');
      w.className = 'hp-tscroll';
      w.setAttribute('tabindex', '0');
      w.setAttribute('role', 'region');
      w.setAttribute('aria-label', T('table', 'Table'));
      t.parentNode.insertBefore(w, t);
      w.appendChild(t);
    });
  }

  /* phones: the care menu, the Journal topics and "Shop by category" are rows that scroll sideways.
     a) the current tab is brought in so that the first visible label starts at the gutter, never cut in half (the
        row scrolls to the start of a tab; when the current tab is near the end, the row gets extra end space so it
        can still start at a tab) (final QA P3-7)
     b) the cut edge fades like the header's category row: right while there is more, left once scrolled */
  var FADE = 56;
  function rowPos(ul, el) { return el.getBoundingClientRect().left - ul.getBoundingClientRect().left + ul.scrollLeft; }
  function alignRow(ul) {
    var act = ul.querySelector('.is-here>a, a[aria-current="page"]');
    if (!act || ul.__hpTouched) return;
    ul.style.paddingRight = '';
    if (ul.scrollWidth <= ul.clientWidth + 2) return;
    var items = Array.prototype.slice.call(ul.children).map(function (li) { return li.firstElementChild || li; });
    var i = items.indexOf(act);
    if (i < 0) return;
    var pad = parseFloat(getComputedStyle(ul).paddingLeft) || 0;
    var right = rowPos(ul, act) + act.getBoundingClientRect().width;
    var room = ul.clientWidth - (i === items.length - 1 ? pad : FADE);
    var target = 0;
    for (var k = 0; k <= i; k++) {
      var c = Math.max(0, rowPos(ul, items[k]) - pad);
      if (right <= c + room) { target = c; break; }
    }
    var max = ul.scrollWidth - ul.clientWidth;
    if (target > max + 1) ul.style.paddingRight = (pad + target - max) + 'px';
    ul.scrollLeft = target;
  }
  function edgeCue(ul) {
    function upd() {
      var max = ul.scrollWidth - ul.clientWidth, over = max > 2;
      ul.classList.toggle('hp-x', over);
      ul.classList.toggle('hp-x-l', over && ul.scrollLeft > 2);
      ul.classList.toggle('hp-x-r', over && ul.scrollLeft < max - 2);
    }
    if (!ul.__hpCue) {
      ul.__hpCue = true;
      var t = false;
      ul.addEventListener('scroll', function () { if (!t) { t = true; requestAnimationFrame(function () { t = false; upd(); }); } }, { passive: true });
      ['pointerdown', 'touchstart', 'wheel'].forEach(function (e) { ul.addEventListener(e, function () { ul.__hpTouched = true; }, { passive: true }); });
    }
    upd();
  }
  function initRail(root) {
    var rows = root.querySelectorAll('.hp-rail-list, .hp-topics ul, .hp-cats');
    rows.forEach(function (ul) { alignRow(ul); edgeCue(ul); });
    return rows;
  }
  /* widths change once the web fonts arrive and when a phone turns: line the rows up again (unless touched) */
  function realign() { initRail(document); }
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(realign);
  window.addEventListener('load', realign);
  var rz;
  window.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(realign, 150); });

  /* policy pages (/policies/*): a "Policies" menu like the care pages' side menu (desktop audit P3-39) */
  function initPolicy() {
    var box = document.querySelector('.shopify-policy__container');
    if (!box || box.querySelector('.hp-polnav')) return;
    var root = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/$/, '');
    var here = location.pathname.replace(/\/$/, '');
    var items = [['/policies/privacy-policy', T('pol_privacy', 'Privacy policy')], ['/policies/terms-of-service', T('pol_terms', 'Terms of service')],
      ['/policies/refund-policy', T('pol_refund', 'Refund policy')], ['/policies/shipping-policy', T('pol_shipping', 'Shipping policy')], ['/pages/contact', T('pol_contact', 'Contact us')]];
    var nav = document.createElement('nav');
    nav.className = 'hh hp hp-polnav';
    nav.setAttribute('aria-label', T('policies', 'Policies'));
    var html = '<p class="hh-label hp-rail-title">' + T('policies', 'Policies') + '</p><ul class="hp-rail-list" role="list">';
    items.forEach(function (it) {
      var url = root + it[0], on = here === url;
      html += '<li' + (on ? ' class="is-here"' : '') + '><a href="' + url + '"' + (on ? ' aria-current="page"' : '') + '>' + it[1] + '</a></li>';
    });
    nav.innerHTML = html + '</ul><div class="hp-rail-help"><p>' + T('need_hand', 'Need a hand?') + '</p><a href="mailto:support@heonjewelry.com">support@heonjewelry.com</a></div>';
    box.appendChild(nav);
  }

  function init(root) {
    root = root || document;
    initPolicy();
    initRail(root);
    initFaq(root);
    initFinder(root);
    initToc(root);
    wrapTables(root);
  }
  ready(function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
